import React from 'react'
import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'contexts/Localization'
import _ from 'lodash'
import { usePollUserVvsBar, usePollUserVvsBoost, usePollVvsBoostPoolData, useUserVvsBoost } from 'state/xVvs/hooks'
import { BIG_ZERO } from 'utils/bigNumber'
import SkeletonCard from 'views/Pool/components/SkeletonCard'
import { CardLayout } from 'views/Pools'
import { VaultCardMini } from 'views/xVvs/component/VaultCard/VaultInnerCard'
import { Text, Box } from 'vvs-uikit'

export default function MyVault() {
  const { t } = useTranslation()
  const { account } = useWeb3React()

  // Poll user data for xVVS
  usePollUserVvsBar(account)
  usePollUserVvsBoost(account)
  usePollVvsBoostPoolData()

  const { userDataLoaded, boostData } = useUserVvsBoost()

  const grouped = _.groupBy(
    boostData.stakes
      .map((x, i) => ({
        ...x,
        stakeId: i,
      }))
      .filter((x) => x.active),
    (p) => p.poolId,
  )

  const aggregated = Object.keys(grouped).map((k) =>
    grouped[k]
      .map((x) => ({
        ...x,
        stakeIds: [] as number[],
        withdrawableStakeIds: [] as number[],
      }))
      .reduce(
        (a, b) => {
          const { withdrawableStakeIds, stakeIds } = a
          const isPeriodFulfilled = b.unlockTimestamp <= new Date().getTime() / 1000
          stakeIds.push(b.stakeId)
          if (isPeriodFulfilled) withdrawableStakeIds.push(b.stakeId)
          return {
            ...a,
            amount: a.amount.plus(b.amount),
            totalLocked: a.totalLocked.plus(!isPeriodFulfilled ? b.amount : BIG_ZERO),
            totalUnlocked: a.totalUnlocked.plus(isPeriodFulfilled ? b.amount : BIG_ZERO),
            poolId: b.poolId,
            stakeIds,
            withdrawableStakeIds,
            lastUnlockTimestamp: Math.max(a.lastUnlockTimestamp, b.unlockTimestamp),
          }
        },
        {
          amount: BIG_ZERO,
          totalLocked: BIG_ZERO,
          totalUnlocked: BIG_ZERO,
          poolId: 0,
          stakeTimestamp: 0,
          unlockTimestamp: 0,
          active: false,
          stakeIds: [],
          withdrawableStakeIds: [],
          lastUnlockTimestamp: 0,
        },
      ),
  )

  const renderBody = () => {
    if (!account) {
      return (
        <Text color="textSubtle" textAlign="center">
          {t('Connect to a wallet to view your vaults.')}
        </Text>
      )
    }
    if (!userDataLoaded) {
      return [0, 1, 2].map((el) => <SkeletonCard key={el} />)
    }
    if (aggregated.length > 0) {
      return aggregated.map((stake) => <VaultCardMini {...stake} totalDeposited={stake.amount} key={stake.poolId} />)
    }
    return (
      <Text color="textSubtle" textAlign="center">
        {t('No records. Get some xVVS to start earning more VVS or partner tokens!')}
      </Text>
    )
  }

  return (
    <Box>
      <CardLayout>{renderBody()}</CardLayout>
    </Box>
  )
}
